import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=2b74173c&scoped=true&"
import script from "./SSOLogin.vue?vue&type=script&lang=js&"
export * from "./SSOLogin.vue?vue&type=script&lang=js&"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=2b74173c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74173c",
  null
  
)

export default component.exports